export const HOME_PATH = '/';
export const PRODUCTS_PATH = `${HOME_PATH}products`;
export const LOGIN_PATH = `${HOME_PATH}auth/login`;
export const REGISTER_PATH = `${HOME_PATH}auth/register`;
export const PROFILE_PATH = `${HOME_PATH}profile`;
export const COUNTRIES_PATH = `${HOME_PATH}countries`;
export const NO_MATCH_PATH = '*';
